import { DesignInput } from '../../../types';

export enum VariableParsing {
  /**
   * Replace "{{app.varName}}" with its value surrounded by `speak-as` tags.
   *
   * @note This should be used for TTS and @see values for voice talents.
   */
  speakAs,
  /**
   * Replace "{{app.varName}}" with its value.
   *
   * @note This should be used for voice talents and @see speakAs for TTS.
   */
  values
}

export type GetTextWithParsedVarsConfig = {
  /** Whether the response is for TTS which determines if `speak-as` tags are added. */
  variableParsing: VariableParsing;
};

/**
 * Replace variable names with their input values in the provided text.
 * @param text Prompt text.
 * @param inputs Prompt inputs to pull values off from.
 * @param config For how the variables should be parsed.
 */
export function getTextWithParsedVars(
  text: string,
  inputs: DesignInput[],
  { variableParsing }: GetTextWithParsedVarsConfig
): string {
  return text.replace(/{{(app|mod)\.([^{}]+)}}/g, (
    match: string,
    variableScope: string,
    variableName: string
  ) => {
    const variable = `${variableScope}.${variableName}`;
    const input = inputs.find((input) => input.argumentName === variable);
    let text = (input?.value ?? input?.defaultValue ?? match).toString();
    const speakAs = input?.speakAs?.toString().toLowerCase();
    if (variableParsing === VariableParsing.speakAs && speakAs) {
      text = `<say-as interpret-as="${speakAs}">${text}</say-as>`;
    }
    return text;
  });
}
